import React, { useEffect } from 'react';
import { IDPaySDK } from 'idpay-b2b-sdk';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import useQuery from '@/hooks/useQuery';
import { sendCustomEvent, sendScreenEvent } from '@useblu/blu-lytics';

import { IframeFinish, LocationState } from './types';

export default function Antifraud() {
  const location = useLocation();
  const navigate = useNavigate();
  const query = useQuery();

  const { id } = useParams();

  const getParam = (key: 'token' | 'transactionId') => {
    const state = (location?.state as LocationState) || {};

    return state[key] || query.get(key) || sessionStorage.getItem(key);
  };

  useEffect(() => {
    const token = getParam('token');
    const transactionId = getParam('transactionId');

    if (!token || !transactionId) {
      navigate('/error');
      return;
    }

    sessionStorage.setItem('token', token || '');
    sessionStorage.setItem('transactionId', transactionId || '');

    sendScreenEvent('link_blu_checkout_iframe_view');

    const onFinish = ({ transaction, type }: IframeFinish) => {
      sessionStorage.removeItem('token');
      sessionStorage.removeItem('transactionId');

      if (type === 'FINISH' && !transaction.captureConcluded) {
        navigate(`/${id}/redirect`);
        return;
      }

      if (type === 'FINISH') {
        sendCustomEvent('link_blu_checkout_iframe_success', {
          transaction_id: transaction.id || transactionId,
        });

        navigate(`/success/${id}`);
      }
    };

    IDPaySDK.init({
      type: 'IFRAME',
      env: process.env.ENVIRONMENT === 'production' ? 'prod' : 'uat',
    });

    IDPaySDK.open({
      token,
      transactionId,
      onFinish,
    });
  }, []);

  return <div />;
}
